
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/clubs",
      function () {
        return require("private-next-pages/products/clubs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/clubs"])
      });
    }
  